import clsx from "clsx";
import Image from "next/image";

import { LEGAL_DOCUMENTS, FAQ_CONTACT_URL, COMPANY_URL } from "../../constants";

import { Link } from "./ui/link";

export default function GlobalFooter() {
  return (
    <div className="hidden-in-nativeapp text-skogecha mt-[20px] flex h-[380px] flex-col-reverse items-center justify-center bg-white md:h-[420px] md:flex-row md:justify-between md:px-[100px] xl:px-[218px]">
      <FooterContent stackClassName="md:h-full md:py-[120px]" />
    </div>
  );
}

/**
 * Footer の中身 (リンク群 / SNS / コピーライト / ロゴマーク)。
 * GlobalFooter と DxPaneFooter の両方で使う共通実装。
 * 外側のラッパー (背景・余白) は呼び出し側で指定する。
 */
export function FooterContent({ stackClassName }: { stackClassName?: string }) {
  return (
    <>
      <div
        className={clsx(
          "flex flex-col space-y-[60px] text-[12px] md:space-y-[30px] md:text-[14px]",
          stackClassName,
        )}
      >
        <div className="space-y-[30px] md:justify-start">
          <div className="flex max-w-[300px] flex-wrap justify-center gap-x-[20px] gap-y-[10px] md:max-w-[490px] md:justify-start md:gap-x-[30px]">
            <Link
              data-analytics-id="global_footer_clicked_faq_contact"
              href={FAQ_CONTACT_URL}
              target="_blank"
              className="whitespace-nowrap"
            >
              FAQ / お問い合わせ
            </Link>
            <Link
              data-analytics-id="global_footer_clicked_company"
              href={COMPANY_URL}
              target="_blank"
              className="whitespace-nowrap"
            >
              運営会社
            </Link>
            <Link
              data-analytics-id="global_footer_clicked_terms_portal"
              href={LEGAL_DOCUMENTS.termsPortalPage.url}
              target="_blank"
              className="whitespace-nowrap"
            >
              {LEGAL_DOCUMENTS.termsPortalPage.title}
            </Link>
          </div>
          <div className="flex flex-row justify-center space-x-[10px] text-[9px] md:justify-start">
            <SocialLink
              imageSrc="/i/footer_instagram.svg"
              alt="instagram"
              link="https://www.instagram.com/sanu_2ndhome/"
              name="Instagram"
            />
            <SocialLink
              imageSrc="/i/footer_spotify.svg"
              alt="spotify"
              link="https://open.spotify.com/user/aq9ukw25yqc0u5i5viakxtay2"
              name="Playlist"
            />
            <SocialLink
              imageSrc="/i/footer_spotify.svg"
              alt="footer_spotify"
              link="https://open.spotify.com/show/5VbiqZ1xGwrygwFE81Fc3M"
              name="SANU RADIO"
            />
          </div>
        </div>
        <p className="text-center text-[12px] md:text-left">© SANU Inc.</p>
      </div>
      <div className="mb-[40px] h-[60px] w-[33px] md:mb-0 md:h-[80px] md:w-[44px]">
        <Image
          src="/i/sanu_logomark.svg"
          alt="SANU logomark"
          width={44}
          height={80}
        />
      </div>
    </>
  );
}

function SocialLink({
  imageSrc,
  alt,
  link,
  name,
}: {
  imageSrc: string;
  alt: string;
  link: string;
  name: string;
}) {
  return (
    <Link
      data-analytics-id="global_footer_clicked_social"
      href={link}
      target="_blank"
    >
      <div className="flex w-[80px] flex-row items-center space-x-[6px]">
        <Image src={imageSrc} alt={alt} width={20} height={20} />
        <p>{name}</p>
      </div>
    </Link>
  );
}
